module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"question":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ","option":"Opzione","yes":"Si","no":"No","continue":"Continua","optionalQuestionButton":"Non voglio rispondere"}}')
  delete Component.options._Ctor
}
